import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-330f1908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"position":"fixed","right":"0","top":"100px","z-index":"999"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { style: {"color":"#ffffff","border":"none","font-size":"14px","width":"100px","height":"32px","border-radius":"4px 0px 0px 4px","background-color":"rgb(248, 209, 146)","z-index":"9999"} }, " 在APP打开 ", -1))
const _hoisted_4 = {
  class: "custom-indicator",
  id: "agentTitle"
}
const _hoisted_5 = { class: "product-wrapper" }
const _hoisted_6 = { class: "product-column" }
const _hoisted_7 = { class: "product-column-desc" }
const _hoisted_8 = { class: "product-column-footer" }
const _hoisted_9 = {
  key: 0,
  class: "discount"
}
const _hoisted_10 = { class: "tag" }
const _hoisted_11 = { class: "init-stock" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "限量", -1))
const _hoisted_13 = { class: "product-top" }
const _hoisted_14 = { class: "packet-name" }
const _hoisted_15 = { style: {"display":"flex","flex-direction":"column","width":"130px"} }
const _hoisted_16 = { style: {"font-size":"12px","font-family":"PingFang SC","color":"#9c7a42"} }
const _hoisted_17 = {
  class: "security-wrapper",
  id: "detail"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-rule" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "group-shu" }),
  /*#__PURE__*/_createElementVNode("p", null, "拍品详情")
], -1))
const _hoisted_19 = { class: "security-wrapper" }
const _hoisted_20 = {
  class: "group-rule",
  id: "vendor"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-shu" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发行方", -1))
const _hoisted_23 = { style: {"font-size":"15px","font-family":"PingFang SC","font-weight":"bold","color":"#a98f60","margin-left":"auto"} }
const _hoisted_24 = { class: "security-wrapper" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-rule" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "group-shu" }),
  /*#__PURE__*/_createElementVNode("p", null, "购买须知")
], -1))
const _hoisted_26 = { class: "security-wrapper" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-rule" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "group-shu" }),
  /*#__PURE__*/_createElementVNode("p", null, "价格须知")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_wx_open_launch_app = _resolveComponent("wx-open-launch-app")!
  const _component_SwipeItem = _resolveComponent("SwipeItem")!
  const _component_Swipe = _resolveComponent("Swipe")!
  const _component_Progress = _resolveComponent("Progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isWeiXin)
      ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          width: "24",
          height: "24",
          src: _ctx.backIcon,
          onClick: _withModifiers(_ctx.back, ["stop"]),
          style: {"position":"fixed","z-index":"999","top":"10px","left":"10px"}
        }, null, 8, ["src", "onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.isWeiXin)
      ? (_openBlock(), _createBlock(_component_van_image, {
          key: 1,
          width: "24",
          height: "24",
          src: _ctx.shareIcon,
          onClick: _withModifiers(_ctx.share, ["stop"]),
          style: {"position":"fixed","z-index":"999","top":"10px","right":"10px"}
        }, null, 8, ["src", "onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.wxPopup)
        ? (_openBlock(), _createBlock(_component_wx_open_launch_app, {
            key: 0,
            id: "launch-btn9",
            appid: "wxf6b9ae5b12f31757",
            extinfo: _ctx.sendData,
            onLaunch: _ctx.handleLaunchFn,
            onError: _ctx.handleErrorFn
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "text/wxtag-template" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["extinfo", "onLaunch", "onError"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.shopData.swiperList)
      ? (_openBlock(), _createBlock(_component_Swipe, {
          key: 2,
          class: "my-swipe",
          loop: true,
          style: {"height":"375px"},
          "indicator-color": "white",
          onChange: _ctx.onChange
        }, {
          indicator: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.current + 1) + "/" + _toDisplayString(_ctx.shopData.swiperList.length), 1)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopData.swiperList, (image, index) => {
              return (_openBlock(), _createBlock(_component_SwipeItem, {
                key: index,
                onClick: ($event: any) => (_ctx.preview(index))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_image, {
                    src: image,
                    height: "375"
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onChange"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.productDesc(_ctx.shopData.packetName)), 1),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.shopData.discount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.shopData.discount.discountStr), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.shopData.tag), 1),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, "  " + _toDisplayString(_ctx.shopData.initStock) + "份", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.productPacketName(_ctx.shopData.packetName)), 1),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, "已售               " + _toDisplayString(_ctx.shopData.process) + "%", 1),
          _createVNode(_component_Progress, {
            color: "#9C7A42",
            percentage: _ctx.shopData.process,
            "show-pivot": false,
            "stroke-width": "6"
          }, null, 8, ["percentage"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopData.detailInfo, (item, i) => {
        return (_openBlock(), _createBlock(_component_van_image, {
          src: item,
          key: i
        }, null, 8, ["src"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _hoisted_22,
        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.shopData.manufacture.companyName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createVNode(_component_van_image, {
        src: _ctx.shopData.purchaseTip
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createVNode(_component_van_image, {
        src: _ctx.shopData.priceTip
      }, null, 8, ["src"])
    ])
  ]))
}